{
  "en": {
    "timetable": {
      "headline": "Organize your school day",
      "today": "Today",
      "month": "Month",
      "week": "Week",
      "day": "Day",
      "weekNumberFormat": "(Week {weekNumber})",
      "dayFormat": "{day}, {date}",
      "previous": "Previous",
      "next": "Next",
      "defaultCalendarTitle": "My Timetable",
      "calendar": "Timetable",
      "createNewTimetable": "Create New Timetable",
      "settings": "Settings",
      "lastSynced": "Last synced:",
      "breakTimeTooltip": "No lessons are displayed during non-teaching periods.",
      "untisSyncedTooltip": "Calendar synced from Untis",
      "sync": {
        "chip": {
          "syncing": "Timetable is currently syncing"
        },
        "toast": {
          "initialSyncing": {
            "title": "Timetable is currently syncing",
            "body": "This may take a moment. You can keep the page open — the appointments will appear automatically once the sync is complete."
          },
          "success": "Timetable successfully synced",
          "errorAuthExpired": "Connection to WebUntis expired. Please reconnect your account.",
          "errorNotConnected": "No WebUntis account connected",
          "errorNotFound": "School year not found in WebUntis",
          "errorGeneric": "Timetable cannot be synced at the moment"
        }
      },
      "offcanvas": {
        "title": "Settings",
        "untisHint": {
          "title": "WebUntis Timetable",
          "description": "This calendar is {highlightSync} with your WebUntis timetable.",
          "highlightSync": "automatically synchronized",
          "bullet1": "In WebUntis, you can {highlightBullet1}.",
          "highlightBullet1": "change or move appointments",
          "bullet2": "In the fobizz timetable, you can {highlightBullet2}.",
          "highlightBullet2": "plan lessons"
        },
        "webuntisTip": {
          "title": "Tip for WebUntis Schools",
          "linkText": "fobizz.com/untis-plattform"
        },
        "sections": {
          "basicSettings": {
            "title": "Basic Settings",
            "dateRangeLabel": "Time Period",
            "dateRange": "From {startDate} to {endDate}",
            "calendarName": "Name",
            "lessonDuration": "Lesson Duration",
            "lessonDurationOption": "{duration} min.",
            "deleteTimetable": "Delete Timetable",
            "validation": {
              "nameRequired": "Please enter a timetable name.",
              "durationRequired": "Please select a lesson duration."
            }
          },
          "breakTimes": {
            "title": "Holidays & Break Times",
            "addButton": "Add New Break Time",
            "editEntry": "Edit Entry",
            "deleteEntry": "Delete Entry",
            "loading": "Loading break times...",
            "alertTitle": "Good to know:",
            "alertDescription": "No course events will be displayed in your timetable during break times."
          },
          "courses": {
            "title": "My Courses",
            "addCourseButton": "Add New Course",
            "editCourse": "Edit Course",
            "deleteCourse": "Delete Course",
            "emptyState": {
              "headline": "Create your first course now",
              "description": "Add courses to organize your timetable.",
              "addButton": "Add Course"
            },
            "loading": "Loading courses..."
          }
        },
        "flash": {
          "updateSuccess": "Settings saved successfully",
          "updateFailed": "Failed to save settings"
        }
      },
      "colors": {
        "label": "Course color",
        "yellow": "Yellow",
        "orange": "Orange",
        "red": "Red",
        "magenta": "Magenta",
        "green": "Green",
        "teal": "Teal",
        "cyan": "Cyan",
        "patrol": "Patrol",
        "purple": "Purple",
        "purpur": "Purpur",
        "gray": "Gray"
      },
      "errors": {
        "failedToLoadEvent": "Failed to load event",
        "failedToSaveEvent": "Event could not be saved"
      },
      "validation": {
        "titleMaxLength": "Title must not exceed {max} characters",
        "courseNameMaxLength": "Course name must not exceed {max} characters"
      },
      "create": {
        "headline": "Create new timetable",
        "form": {
          "titleLabel": "Title",
          "namePlaceholder": "Enter title...",
          "dateRangeLabel": "Start and end date",
          "dateFromLabel": "From",
          "dateToLabel": "To",
          "submitting": "Creating timetable..."
        },
        "validation": {
          "titleRequired": "Please enter a name",
          "startDateRequired": "Please select a start date",
          "invalidStartDate": "Please enter a valid start date",
          "endDateRequired": "Please select an end date",
          "invalidEndDate": "Please enter a valid end date",
          "endDateAfterStart": "End date must be after or equal to start date"
        },
        "flash": {
          "created": "Timetable successfully created",
          "createFailed": "Error creating timetable"
        }
      },
      "createEvent": {
        "title": "Create New Event",
        "courseLabel": "Create event for:",
        "courseSelection": {
          "placeholder": "Select...",
          "newCourse": "New Course",
          "otherEvent": "Other Event",
          "selectCourse": "Select course",
          "loading": "Loading courses...",
          "courses": "Courses",
          "courseSectionLabel": "Class in Course",
          "otherEventSectionLabel": "Other Event"
        },
        "dateAndRecurrence": "Day and recurrence",
        "recurrenceLabel": "Recurrence",
        "recurrenceOptions": {
          "onetime": "One-time",
          "weekly": "Weekly",
          "biweekly": "Biweekly",
          "quadweekly": "Every 4 weeks"
        },
        "durationLabel": "Duration",
        "eventTitleLabel": "Event Title",
        "eventTitlePlaceholder": "Enter title...",
        "courseNameLabel": "Course Title",
        "courseNamePlaceholder": "e.g. Math 7B",
        "courseColorLabel": "Choose Color",
        "errors": {
          "endTimeBeforeStart": "End time must be after start time",
          "createFailed": "Failed to create event"
        }
      },
      "courseModal": {
        "courseNameLabel": "Course Name",
        "courseNamePlaceholder": "Enter title...",
        "courseColorLabel": "Color",
        "classroomLabel": "Link Shared Space",
        "classroomPlaceholder": "Not linked",
        "validation": {
          "courseNameRequired": "Please enter a course name"
        },
        "createCourse": {
          "title": "Create New Course",
          "create": "Create",
          "errors": {
            "createFailed": "Failed to create course"
          }
        },
        "editCourse": {
          "title": "Edit Course",
          "save": "Save",
          "errors": {
            "editFailed": "Failed to update course"
          }
        }
      },
      "deleteCourse": {
        "title": "Delete Course?",
        "message": "Warning: If you delete this course, all associated appointments will be cancelled (total: {count}). Are you sure you want to delete the entire course?",
        "delete": "Yes, delete",
        "errors": {
          "deleteFailed": "Failed to delete course"
        }
      },
      "breakTimeModal": {
        "titleLabel": "Title",
        "titlePlaceholder": "Summer Break, Fall Break, ...",
        "startDateLabel": "From",
        "endDateLabel": "To",
        "validation": {
          "titleRequired": "Please enter a title",
          "startDateRequired": "Please select a start date",
          "endDateRequired": "Please select an end date",
          "endDateMustBeAfterStartDate": "End date must be after start date"
        },
        "createBreakTime": {
          "title": "Add Break Time",
          "success": "Break time added successfully",
          "errors": {
            "createFailed": "Failed to add break time"
          }
        },
        "editBreakTime": {
          "title": "Edit Break Time",
          "success": "Break time updated successfully",
          "errors": {
            "editFailed": "Failed to update break time"
          }
        }
      },
      "deleteBreakTime": {
        "title": "Delete Break Time?",
        "message": "The entry will be removed from your timetable.",
        "delete": "Yes, delete",
        "errors": {
          "deleteFailed": "Failed to delete break time"
        }
      },
      "deleteTimetable": {
        "title": "Delete Timetable?",
        "message": "Do you really want to delete the timetable {calendarName}?",
        "delete": "Yes, delete",
        "success": "Timetable deleted successfully",
        "errors": {
          "deleteFailed": "Failed to delete timetable"
        }
      },
      "lessonPlan": {
        "entryButton": "Create lesson plan 🤓",
        "tabsLabel": "Lesson and lesson plan",
        "lessonTab": "Lesson",
        "planTab": "Lesson plan",
        "minutes": "Min.",
        "bufferDuration": "approx. {minutes} min. · optional",
        "loadErrorTitle": "Lesson plan could not be loaded",
        "loadError": "Please reload the page or try again later.",
        "form": {
          "title": "Create lesson plan",
          "description": "Create a structured lesson plan based on the details of this lesson.",
          "sourceContext": "Title, notes & materials",
          "instruction": "What else should be considered? (optional)",
          "instructionPlaceholder": "e.g., group work and a brief consolidation",
          "automatic": "Automatic",
          "entryType": "Type of lesson entry",
          "entryTypes": {
            "problem": "Problem-oriented",
            "informative": "Informative",
            "associative": "Associative",
            "playful": "Playful"
          },
          "lessonFocus": "Lesson focus",
          "lessonFocuses": {
            "presentation": "Presentation",
            "groupwork": "Group work",
            "solo_work": "Individual work",
            "creativity": "Creativity"
          }
        },
        "generate": "Create lesson plan 🤓",
        "generating": "Creating lesson plan…",
        "generationError": "The lesson plan could not be created. You can try again.",
        "learningObjectives": "Learning objectives",
        "curriculum": {
          "basedOn": "Based on curricula for {place}.",
          "basedOnWithoutPlace": "Based on curricula.",
          "hide": "Hide",
          "noSubject": "We could not derive a subject from the course name. Name the course after the subject, for example \"Mathematics 7b\", then the AI will use a curriculum for the next draft.",
          "notFound": "We did not find a suitable curriculum for this lesson.",
          "show": "Show",
          "unknownRegion": "Without a state, the AI does not use a curriculum.",
          "upload": "Upload your own"
        },
        "phases": "Lesson flow",
        "primaryActors": {
          "learners": "Students",
          "mixed": "Teacher and Students",
          "teacher": "Teacher"
        },
        "description": "Description",
        "materials": "Materials",
        "materialType": "Material type",
        "selectMaterial": "Select material",
        "createMaterial": "Create material",
        "materialGenerating": "Creating material…",
        "materialPending": "Preparing material…",
        "materialError": "The material could not be created. Please try again.",
        "openMaterial": "Open material",
        "createProject": "Create project 🤓",
        "projectGenerating": "Creating project…",
        "openProject": "Open project",
        "projectError": "The project could not be created. Please try again.",
        "projectClassTypeOnetimeError": "No more projects can be created in a 24-hour Shared Space.",
        "inProject": "In the project",
        "projectModal": {
          "title": "Create project for \"{title}\"",
          "description": "Select the phases from which the tasks are created. Name, description and tools are derived from them, already created materials of the phases are linked.",
          "phases": "Phases",
          "phasesHelp": "Phases in which the teacher primarily acts are not preselected.",
          "actor": {
            "teacher": "Teacher",
            "learners": "Students",
            "mixed": "Together"
          },
          "noPhaseSelected": "Select at least one phase.",
          "teacherOnlyPhases": "Select at least one phase in which learners are actively working.",
          "help": "Optional: Notes on the task, the tone or the unlocked tools."
        },
        "instructionsModal": {
          "material": {
            "title": "Create {material} for \"{phase}\"",
            "description": "Learning objectives, target group, phase content, and action form are automatically transferred.",
            "help": "Optional: scope, difficulty level, task format, or differentiation."
          },
          "placeholder": "Add further notes …"
        },
        "materialKinds": {
          "assistant": "AI Assistant",
          "classroom_screen": "Classroom screen",
          "pinboard": "Pinboard",
          "survey": "Survey",
          "text_document": "Text document",
          "web_page": "Website",
          "word_cloud": "Word Cloud",
          "worksheet": "Worksheet"
        }
      },
      "eventDetails": {
        "headlineLesson": "Plan Lesson",
        "headlineOther": "Plan Other Event",
        "cardHeadlineOther": "Other Event",
        "backLink": "Timetable Overview",
        "saved": "Changes saved",
        "form": {
          "titlePlaceholderLesson": "Enter lesson topic",
          "titlePlaceholderOther": "Enter title",
          "titleLabel": "Title",
          "notesLabel": "Notes",
          "notesPlaceholder": "Plan lesson",
          "notesPlaceholderOther": "Plan appointment",
          "materialsLabel": "Materials",
          "projectsLabel": "Projects",
          "attachProjectButton": "Attach project",
          "dropzoneHint": "Drag & drop here or",
          "dropzoneSelectFile": "select file",
          "lessonTopicLabel": "Lesson topic",
          "lessonTopicPlaceholder": "Here you can summarize the lesson topic from the sections above with the help of AI.",
          "lessonTopicHint": "You can use AI to summarize the lesson. Select the content that should be used.",
          "summarizeButton": "Summarize lesson",
          "summarizeAgainButton": "Re-summarize lesson",
          "summarizingButton": "Summarizing…",
          "syncToUntisButton": "Sync to WebUntis",
          "summarizeError": "Error summarizing the lesson",
          "syncSuccess": "Lesson topic synced to WebUntis",
          "syncError": "Sync to WebUntis failed"
        },
        "addContent": {
          "button": "Add content",
          "dialogTitle": "Add content",
          "searchPlaceholder": "Search term...",
          "confirm": "Add",
          "myContentTab": "My Content",
          "toTeachTab": "to teach",
          "toTeachAttachFailed": "The worksheet is in your My Content, but could not be added to the lesson."
        },
        "materialsError": "Error saving materials",
        "discontinueCourse": "Discontinue course",
        "discontinueSeries": "Discontinue series",
        "previousEvent": "Previous Lesson",
        "nextEvent": "Next Lesson",
        "cancelledLabel": "Cancelled",
        "cancelledNoticeTitleLesson": "This lesson is cancelled.",
        "cancelledNoticeTitleOther": "This appointment is cancelled.",
        "cancelledNoticeDescription": "All information is retained and can be reused later."
      },
      "discontinueCourse": {
        "lesson": {
          "title": "Discontinue Course?",
          "message": "If you discontinue the course, this appointment and all following appointments of the course will be cancelled.",
          "description": "Do you really want to cancel all {count} following appointments of this course?",
          "confirm": "Yes, discontinue"
        },
        "other": {
          "title": "End Event Series?",
          "message": "If you end the event series, this appointment and all following appointments of the series will be cancelled.",
          "description": "Do you really want to cancel all {count} following appointments of this series?",
          "confirm": "Yes, end"
        },
        "successMessage": "Course discontinued successfully",
        "errorMessage": "Error discontinuing course"
      },
      "cancelEvent": {
        "lesson": {
          "title": "Cancel Lesson?",
          "message": "This lesson will be removed from your calendar.",
          "confirm": "Yes, cancel",
          "buttonLabel": "Cancel Lesson"
        },
        "other": {
          "title": "Cancel Event?",
          "message": "This event will be removed from your calendar.",
          "confirm": "Yes, cancel",
          "buttonLabel": "Cancel Event"
        },
        "successMessage": "Event cancelled successfully",
        "errorMessage": "Error cancelling event"
      },
      "restoreEvent": {
        "lesson": {
          "buttonLabel": "Restore lesson"
        },
        "other": {
          "buttonLabel": "Restore appointment"
        },
        "successMessage": "The appointment has been restored",
        "errorMessage": "Error restoring the appointment"
      },
      "linkClassroom": {
        "title": "Connect shared space to this course",
        "labelTooltip": "Connect this course with a dedicated digital space. You can then conveniently add projects and share learning material with this learning community.",
        "selectPlaceholder": "Select",
        "confirm": "Connect",
        "cancel": "Cancel",
        "success": "Shared space connected successfully",
        "error": "Error connecting shared space",
        "buttonLabel": "Connect shared space"
      },
      "attachProject": {
        "title": "Attach project to lesson",
        "selectLabel": "Projects from {schoolClassName}",
        "selectPlaceholder": "Select",
        "newProject": "New project",
        "confirm": "Attach",
        "cancel": "Cancel",
        "error": "This project could not be attached"
      },
      "untisImportTeaser": {
        "text": "Does your school use WebUntis? Then you can easily import your timetable. Find more information here:"
      },
      "untisSyncWarning": {
        "title": "Attention",
        "body": "Only the “{highlight}” will be transferred to WebUntis — all other content stays in fobizz.",
        "bodyHighlight": "Lesson Topic Summary",
        "callout": "Existing content in the “Lesson Topic” field in WebUntis will be overwritten.",
        "confirmButton": "Ok, understood",
        "cancelButton": "Cancel",
        "dontShowAgain": "Don't show this again"
      },
      "trialModal": {
        "title": "Your Gift: 30 Days of fobizz Pro",
        "intro": "You've just connected your Untis timetable with fobizz — great to have you here!",
        "body": "To let you fully try out fobizz, we're giving you 30 days of Pro: {highlight}.",
        "bodyHighlight": "AI Chat, Create materials, and all courses",
        "cancellation": "No need to cancel — your trial period ends automatically. Your timetable remains and continues to sync with WebUntis.",
        "email": "We'll also send you the details via email.",
        "confirmButton": "To the Timetable"
      }
    }
  }
}
